import {
    IInstitutionResponse,
    IInstitutionListResponse,
    IInstitutionDeleteResponse,
    IInstitutionCreateBody,
    IInstitutionUpdateBody,
    IInstitutionStatusBody,
    IInstitutionRenewBody,
    IInstitutionDeviceListResponse,
    IInstitutionDeviceResponse,
    IInstitutionDeviceStatusBody,
    IInstitutionResetPasswordBody,
    IInstitutionResetPasswordResponse,
} from "@/api/types/institution";
import AxiosInstance from "@/api";
import { API_ROUTES } from "@/constants/api-routes";

export const GetInstitutions = async () => {
    const response = await AxiosInstance.get<IInstitutionListResponse>(API_ROUTES.INSTITUTION.LIST);

    return response.data;
};

export const GetExpiringInstitutions = async () => {
    const response = await AxiosInstance.get<IInstitutionListResponse>(API_ROUTES.INSTITUTION.EXPIRING);

    return response.data;
};

export const GetInstitutionById = async (id: number) => {
    const response = await AxiosInstance.get<IInstitutionResponse>(API_ROUTES.INSTITUTION.GET_BY_ID(id));

    return response.data;
};

export const CreateInstitution = async (body: IInstitutionCreateBody) => {
    const response = await AxiosInstance.post<IInstitutionResponse>(API_ROUTES.INSTITUTION.CREATE, body);

    return response.data;
};

export const UpdateInstitution = async (id: number, body: IInstitutionUpdateBody) => {
    const response = await AxiosInstance.put<IInstitutionResponse>(API_ROUTES.INSTITUTION.UPDATE(id), body);

    return response.data;
};

export const DeleteInstitution = async (id: number) => {
    const response = await AxiosInstance.delete<IInstitutionDeleteResponse>(API_ROUTES.INSTITUTION.DELETE(id));

    return response.data;
};

export const UpdateInstitutionStatus = async (id: number, body: IInstitutionStatusBody) => {
    const response = await AxiosInstance.patch<IInstitutionResponse>(API_ROUTES.INSTITUTION.UPDATE_STATUS(id), body);

    return response.data;
};

export const RenewInstitutionContract = async (id: number, body: IInstitutionRenewBody) => {
    const response = await AxiosInstance.post<IInstitutionResponse>(API_ROUTES.INSTITUTION.RENEW(id), body);

    return response.data;
};

export const ResetInstitutionPassword = async (id: number, body: IInstitutionResetPasswordBody) => {
    const response = await AxiosInstance.patch<IInstitutionResetPasswordResponse>(
        API_ROUTES.INSTITUTION.RESET_PASSWORD(id),
        body
    );

    return response.data;
};

export const GetInstitutionDevices = async (id: number) => {
    const response = await AxiosInstance.get<IInstitutionDeviceListResponse>(API_ROUTES.INSTITUTION.DEVICES.LIST(id));

    return response.data;
};

export const UpdateInstitutionDeviceStatus = async (id: number, deviceId: number, body: IInstitutionDeviceStatusBody) => {
    const response = await AxiosInstance.patch<IInstitutionDeviceResponse>(
        API_ROUTES.INSTITUTION.DEVICES.UPDATE_STATUS(id, deviceId),
        body
    );

    return response.data;
};

export const RemoveInstitutionDevice = async (id: number, deviceId: number) => {
    const response = await AxiosInstance.delete<IInstitutionDeleteResponse>(
        API_ROUTES.INSTITUTION.DEVICES.REMOVE(id, deviceId)
    );

    return response.data;
};
